package com.merkost.handpass.admin

import com.merkost.handpass.sharedweb.theme.Bg
import com.merkost.handpass.sharedweb.theme.MotionReduced
import com.merkost.handpass.sharedweb.theme.OnSurface
import com.merkost.handpass.sharedweb.theme.WebType
import com.merkost.handpass.sharedweb.theme.WebTransitions
import com.merkost.handpass.theme.HandpassTokens
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import org.jetbrains.compose.web.css.px

@InitSilk
fun initAdminStyles(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyle("body") {
        base {
            Modifier
                .fontFamily(HandpassTokens.Fonts.Primary, "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "sans-serif")
                .fontSize(WebType.Base)
                .lineHeight(1.5)
                .color(OnSurface.value())
                .backgroundColor(Bg.value())
                .margin(0.px)
                .styleModifier {
                    property("-webkit-font-smoothing", "antialiased")
                    property("text-rendering", "optimizeLegibility")
                    property("transition", "background-color ${WebTransitions.Normal}, color ${WebTransitions.Normal}")
                }
        }
    }
}

fun injectReducedMotionGuard() {
    val doc = kotlinx.browser.document
    if (doc.getElementById("admin-reduced-motion") != null) return
    val style = doc.createElement("style")
    style.setAttribute("id", "admin-reduced-motion")
    style.textContent = "@media (prefers-reduced-motion: reduce){*,*::before,*::after{animation-duration:${MotionReduced.value()}!important;animation-iteration-count:1!important;transition-duration:${MotionReduced.value()}!important;scroll-behavior:auto!important}}"
    doc.head?.appendChild(style)
}

fun injectBaseGuard() {
    val doc = kotlinx.browser.document
    if (doc.getElementById("admin-base-guard") != null) return
    val style = doc.createElement("style")
    style.setAttribute("id", "admin-base-guard")
    style.textContent =
        "h1{font-size:26px;margin:0;text-wrap:balance}h2{font-size:22px;margin:0;text-wrap:balance}h3{font-size:18px;margin:0;text-wrap:balance}h4{font-size:16px;margin:0;text-wrap:balance}" +
        "button{font:inherit;font-size:13px;line-height:1.5;cursor:pointer}" +
        "input,textarea,select{font:inherit}img,svg{max-width:100%}" +
        ".tabular-nums{font-variant-numeric:tabular-nums}"
    doc.head?.appendChild(style)
}

fun injectGoogleFonts() {
    val doc = kotlinx.browser.document
    val link = doc.createElement("link")
    link.setAttribute("rel", "stylesheet")
    link.setAttribute("href", "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap")
    doc.head?.appendChild(link)

    val preconnect1 = doc.createElement("link")
    preconnect1.setAttribute("rel", "preconnect")
    preconnect1.setAttribute("href", "https://fonts.googleapis.com")
    doc.head?.appendChild(preconnect1)

    val preconnect2 = doc.createElement("link")
    preconnect2.setAttribute("rel", "preconnect")
    preconnect2.setAttribute("href", "https://fonts.gstatic.com")
    preconnect2.setAttribute("crossorigin", "")
    doc.head?.appendChild(preconnect2)
}
